import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { BarBaseInputCellEditor } from '../bar-base-input-cell-editor';
import { IBarTextareaCellEditorParams } from './bar-textarea-cell-editor-params.contract';

@Component({
    selector: 'bar-textarea-cell-editor',
    templateUrl: './bar-textarea-cell-editor.html',
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
/** @deprecated Use native textarea cell editor. AG grid editor for regular input fields. */
export class BarTextareaCellEditor extends BarBaseInputCellEditor<IBarTextareaCellEditorParams> {
    protected rows: number;
    protected width: string;

    isPopup(): boolean {
        return true;
    }

    afterGuiAttached(): void {
        // wait for ag-popup-editor component, implement the 0-timeout hack
        setTimeout(() => {
            const popup: HTMLElement = document.querySelector('.ag-popup-editor');
            popup.style.width = this.width;
        }, 0);
    }

    getValue() {
        let value = super.getValue() as string;

        if (this.params.autoTrim && value) {
            value = value.trim();
            this.formControl.setValue(value);
        }

        return value;
    }

    protected onInit(): void {
        this.rows = this.params.rows || 5;
        this.width = this.params.width || `${this.params['eGridCell']['clientWidth']}px` || '300px';
    }
}
